"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
/**
 * @param {Function} component
 * @returns {object}
 */


var catchRender = function catchRender(component) {
  var newComponent = function newComponent() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var result = null;

    try {
      result = component(props);
    } catch (e) {
      if (_typeof(e) !== 'object' || _react.default.isValidElement(e)) result = e;else throw e;
    }

    return result;
  };

  newComponent.displayName = // @ts-ignore
  component.displayName || component.name || 'Component';
  return newComponent;
};

var _default = catchRender;
exports.default = _default;